/**
 * The services a whole-project rewind or a version restore changed (vfs-service rollbackAll / restoreVersion
 * `commits`: `[{ repo, sha }]`), by the key the editor's cache and the file tree use: the service's own path,
 * `services/backend`, the same as `configuration.services[...].name`. Never the bare `backend`: vfs-service's GET
 * /tree resolves paths from the project root, so `?path=backend` is a 404 and the editor never sees the new files.
 * Only the repos that got a commit (`sha`), only services (the brain and the project root are not in the editor).
 */
export function changedServiceKeys(commits) {
  const keys = (commits || [])
    .filter((commit) => commit && commit.sha && typeof commit.repo === 'string' && /^services\/[^/]+\/?$/.test(commit.repo))
    .map((commit) => commit.repo.replace(/\/+$/, ''));
  return [...new Set(keys)];
}

export default changedServiceKeys;
